// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img.logoHeight_85[data-v-67f31b2b]{height:85px!important;transition:.5s ease-in-out}img.logoHeight_75[data-v-67f31b2b]{height:75px!important;transition:.5s ease-in-out}img.logoHeight_55[data-v-67f31b2b]{height:55px!important;transition:.5s ease-in-out}", ""]);
// Exports
module.exports = exports;
